import type { NextPage } from 'next';
import { ResponsiveSection, Stack } from '@stitch-fix/mode-react';
import { Layout } from '../../../components/Layout';
import { CreditContent } from '../../../features/accountCredit/components/CreditContent';
import { PromoCodeInput } from '../../../features/accountCredit/components/PromoCode/PromoCodeInput';
import { OtherActions } from '../../../features/accountCredit/components/OtherActions';
import { SEOData } from '../../../components/SEOData';
const AccountCreditPage: NextPage = () => {
  return <Layout>
      <ResponsiveSection>
        <SEOData title="Account Credit | Stitch Fix" canonicalUrl="https://www.stitchfix.com/account/credit" robots="noindex, nofollow" />
        <Stack width="fit-content" spacing={2.5} my={2} mx="auto">
          <CreditContent />
          <PromoCodeInput />
          <OtherActions />
        </Stack>
      </ResponsiveSection>
    </Layout>;
};
export default AccountCreditPage;